import { Flex } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';




const SmartButton = ({icon, text, number, to, className= 'border-e-2'}) => {
  function containsNumber(str) {
    if (typeof(str) === 'string') return str.match(/\d+/) !== null;
  }

  return (
    <Link to={to}>
      <Flex vertical={false} align='center' gap={10} className={className+' border-0 p-1 ps-2'} style={{width: '120px', height: '45px'}}>
        <div>{icon}</div>
        <div>
          <span className={(containsNumber(number) || typeof(number)==='number') ? 'text-[#189aa0] text-sm font-semibold': 'text-slate-600 text-sm'}>{number}</span>
          <p className='m-0 pb-1 text-sm text-slate-600'>{text}</p>
        </div>
      </Flex>
    </Link>
  )
}

export default SmartButton;